import React, { useEffect, useState } from 'react'
import '../table.css'
import { DataGrid } from '@mui/x-data-grid'
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import axios from 'axios';
import { Alert, CircularProgress, Snackbar } from '@mui/material';
import AddCoupons from './AddCoupon';
import EditCoupons from './EditCoupon';
import { CSVLink } from 'react-csv';
import { couponDataGrid, couponHeaders } from '../../constant/dataGrid';
import { fetchData, handleDeleteActionClick } from '../../helpers/public';
import { useCookies } from 'react-cookie';

const messages = {
    a: "الرجاء اختيار كوبون",
    c: "هل انت متاكد انك تريد الحذف",
    b: 'خطأ في العملية'
}
const url = `${process.env.REACT_APP_URL}/houdix/seen/admin/coupons`

const Coupons = () => {

    const [cookies, setCookie, removeCookie] = useCookies(['token']);


    const [message, setMessage] = useState('')
    const [open, setOpen] = React.useState(false);
    const [addOpen, setAddOpen] = React.useState(false);
    const [editOpen, setEditOpen] = React.useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [csvRows, setCsvRows] = useState([]);

    const handleAddOpen = () => setAddOpen(true);
    const handleAddClose = () => setAddOpen(false);
    const handleEditOpen = () => setEditOpen(true);
    const handleEditClose = () => setEditOpen(false);

    const handleAddActionClick = () => {
        handleAddOpen();
    };

    const handleEditActionClick = (row) => {
        setSelectedItem(row)
        handleEditOpen();
    };

    const handleClickAlert = () => {
        setOpen(true);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const handleToggleActive = () => {
        const token = cookies['token'];
        if (selectedRows.length === 0) {
            alert('Please select rows to update.');
            return;
        }
        const confirmation = window.confirm('Are you sure you want to update this row?');
        if (confirmation) {
            axios
                .put(`${process.env.REACT_APP_URL}/houdix/seen/admin/coupons`, { ids: selectedRows }, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
                )
                .then((response) => {
                    if (response.status === 200) {
                        setMessage('تمت العملية بنجاح')
                        handleClickAlert()
                    }
                })
                .catch((error) => {
                    setMessage('خطأ في العملية')
                });
        }
    };

    const handleDeleteActionClick = (selectedRows, setMessage, handleClickAlert, messages, url) => {
        const token = cookies['token']
        if (selectedRows.length === 0) {
            alert(messages.a);
            return;
        }
        const confirmation = window.confirm(messages.c);
        if (confirmation) {
            axios
                .delete(url, {
                    data: { ids: selectedRows },
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                .then((response) => {
                    if (response.status === 200) {
                        setMessage("تمت العملية بنجاح")
                        handleClickAlert()
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setMessage(messages.b);
                    handleClickAlert()
                });
        }
    };

    useEffect(() => {
        const token = cookies['token']
        // fetchData(url, setRows, setIsLoading, cookies);
        const fetchData = async (url, setRows, setIsLoading, setCsvRows, token) => {
            try {
                const response = await axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setRows(response.data);
                setIsLoading(false);
                if (setCsvRows) {
                    setCsvRows(response.data)
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData(url, setRows, setIsLoading, cookies, token)
    }, [open]);

    if (isLoading) {
        return (
            <div style={{ display: 'flex', height: "100vh", justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <>
            <div className='container'>
                <div className='title'>
                    <div>
                        <button onClick={handleAddActionClick}>إضافة</button>
                        <button onClick={handleToggleActive}>تعديل</button>
                        <button>
                            <CSVLink style={{ textDecoration: "none", color: 'black' }} data={csvRows} headers={couponHeaders} filename={"coupons.csv"}>
                                CSV
                            </CSVLink>
                        </button>
                        {selectedRows.length !== 0 && <button onClick={() => { handleDeleteActionClick(selectedRows, setMessage, handleClickAlert, messages, url) }}>حذف</button>} 
                    </div>
                    <div>
                        <span className='main-title'>الكوبونات</span>
                    </div>
                </div>
                <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <div style={{ height: 'calc(100vh - 130px)', width: '100%' }}>
                            <DataGrid
                                sx={{ ".MuiDataGrid-columnHeaderTitle": { fontWeight: "700" }, ".MuiSvgIcon-root": { color: "#240259" }, '.MuiTablePagination-root': { direction: 'ltr' } }}
                                hideFooter={false}
                                rows={rows}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 9,
                                        },
                                    },
                                }}
                                columns={couponDataGrid(ModeEditIcon, handleEditActionClick)}
                                checkboxSelection
                                pageSizeOptions={[9]}
                                onRowSelectionModelChange={(itm) => {
                                    const selectedRowsData = itm.map((id) => rows.find((row) => row.id === id));
                                    setCsvRows(selectedRowsData);
                                    setSelectedRows(itm);
                                }}
                                disableRowSelectionOnClick
                                getRowClassName={(params) =>
                                    params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even'
                                }
                                style={{ border: '5px solid #DFDFDF', borderRadius: '32px 32px 0 0 ', direction: "rtl", borderBottom: 'none', backgroundColor: "#FFFFFF" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {addOpen && <AddCoupons handleClose={handleAddClose} handleClickAlert={handleClickAlert} setMessage={setMessage}/>}
            {editOpen && <EditCoupons handleClose={handleEditClose} selectedRows={selectedItem} handleClickAlert={handleClickAlert} setMessage={setMessage}/>}
            <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseAlert} >
                <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%', backgroundColor: '#240259', color: 'white' }}>
                    {message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default Coupons
